// extracted by mini-css-extract-plugin
export default {"popoverContainer":"BulkEdit_popoverContainer__qBsIO","pressed":"BulkEdit_pressed__qMK-h"};